<div class="multi-select-dropdown form-control">
  <button
    #triggerButton
    type="button"
    class="multi-select-dropdown__trigger focus-outline"
    cdkOverlayOrigin
    #trigger="cdkOverlayOrigin"
    [attr.id]="triggerId || null"
    [attr.aria-expanded]="open"
    [attr.aria-controls]="open ? panelId : null"
    aria-haspopup="listbox"
    [attr.aria-labelledby]="ariaLabelledBy || null"
    (click)="onTriggerClick($event)"
  >
    <span class="multi-select-dropdown__trigger-text">{{ triggerText }}</span>
    <span class="multi-select-dropdown__arrow" aria-hidden="true">
      <!-- Same glyph as the outline dropdown, drawn as SVG so high contrast can recolour it. -->
      <svg
        viewBox="0 0 24 24"
        width="24px"
        height="24px"
        focusable="false"
        aria-hidden="true"
      >
        <path d="M7 10l5 5 5-5z" />
      </svg>
    </span>
  </button>
  <ng-template
    cdkConnectedOverlay
    [cdkConnectedOverlayOrigin]="trigger"
    [cdkConnectedOverlayOpen]="open"
    [cdkConnectedOverlayPositions]="panelPositions"
    [cdkConnectedOverlayWidth]="triggerButton.offsetWidth"
    [cdkConnectedOverlayHasBackdrop]="true"
    [cdkConnectedOverlayDisableClose]="true"
    cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"
    [cdkConnectedOverlayFlexibleDimensions]="true"
    [cdkConnectedOverlayPush]="true"
    [cdkConnectedOverlayViewportMargin]="8"
    (backdropClick)="onBackdropClick()"
    (overlayKeydown)="onOverlayKeydown($event)"
    (attach)="onOverlayAttach()"
  >
    <div
      class="multi-select-dropdown__panel"
      role="listbox"
      aria-multiselectable="true"
      tabindex="-1"
      cdkTrapFocus
      cdkTrapFocusAutoCapture
      [attr.id]="panelId"
      [attr.aria-labelledby]="ariaLabelledBy || null"
    >
      @for (item of items; track item.id) {
        <div
          class="multi-select-dropdown__row"
          role="option"
          [attr.aria-selected]="isSelected(item.id)"
        >
          <span
            class="multi-select-dropdown__label"
            (click)="onToggleItem(item.id)"
            >{{ item.label }}</span
          >
          <mat-checkbox
            class="multi-select-dropdown__checkbox"
            [checked]="isSelected(item.id)"
            (click)="$event.stopPropagation(); onToggleItem(item.id)"
          ></mat-checkbox>
        </div>
      }
    </div>
  </ng-template>
</div>
